import { ScanSearch, CircleAlert } from 'lucide-react';
import { capitalize } from 'lodash';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

import CreateInvitationDialog from './CreateInvitationDialog';

const EmptyInvitation = ({ invitePartyRole, canAdd }: { invitePartyRole: string; canAdd: boolean }) => {
  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="shrink-0">
        <CardTitle className="flex items-center gap-2">
          {capitalize(invitePartyRole)} organization & primary contact
          <span className="text-orange-700 flex items-center gap-1">
            <CircleAlert className="size-3.5" />
            <i className="text-xs font-normal">Required</i>
          </span>
        </CardTitle>
        <CardDescription>
          Which organization should be listed as the {invitePartyRole}, and who is their primary contact?
        </CardDescription>
      </CardHeader>
      <CardContent className="grow">
        <div className="p-6 bg-white rounded-lg border border-dashed border-border text-center space-y-6 h-[366px] flex flex-col justify-center items-center">
          <div className="size-12 bg-white rounded-md border border-border flex items-center justify-center mx-auto shadow-xs">
            <ScanSearch className="size-6 text-foreground" />
          </div>
          {canAdd && <CreateInvitationDialog />}
        </div>
      </CardContent>
    </Card>
  );
};

export default EmptyInvitation;
